var WaterStages = function () {

	this.init = function () {

		this.waterStagesSlick();
		equalizer();

	}

	this.waterStagesSlick = function () {
		if ($(window).width() < 992 && !$('[data-component="water-stages"] .slick').hasClass('slick-initialized')) {

			$('[data-component="water-stages"] .stages-slick').slick({
				dots: false,
				slidesToShow: 4,
				slidesPerRow: 1,
				rows: 2,
				infinite: false,
				arrows: false,
				responsive: [
					{
					breakpoint: 992,
					settings: {
						rows: 3,
						slidesToShow: 1,
						slidesPerRow: 1,
						dots: true
					}
				}]
			});
		} else if ($(window).width() >= 992) {
			if ($('[data-component="water-stages"] .slick').hasClass('slick-initialized')) {
				$('[data-component="water-stages"] .slick').slick('unslick');
			}
		}
	}

	$(window).on('resize', function () {
		equalizer();
	})

	function equalizer() {
		var height = 0;
		if (window.innerWidth <= 991) {
			$("[data-component='water-stages'] [data-component='card-text']").css('height', 'auto');

		} else {
			$("[data-component='water-stages'] [data-component='card-text']").each(function () {
				$(this).css('height', 'auto');
				if ($(this).outerHeight() > height) {
					height = $(this).outerHeight();
				}
			});
			$("[data-component='water-stages'] [data-component='card-text']").outerHeight(height);
		}
	}

	return this.init();
}
